export default __webpack_public_path__ + "static/media/025-cpu.abedfb31.svg";